import { API } from "aws-amplify";
import { updateConnection, responseChampionRequest } from "@/graphql/mutations";
import { UtilsUsecase } from "./types";
import { userTypeConvert } from "@/utils/helper";

export async function mentorshipRequestUsecase(payload: any, utils: UtilsUsecase) {
  try {
    await API.graphql({
      query: updateConnection,
      variables: {
        input: {
          id: payload?.id,
          status: payload?.purpose === "ACCEPTED" ? "APPROVED" : "REJECTED",
          _version: payload?._version,
        },
      },
    });
    await utils.refetch();
    utils.successModal({
      show: true,
      title:
        payload?.purpose === "ACCEPTED"
          ? "You Are Now Connected"
          : "Connection Declined",
      body:
        payload?.purpose === "ACCEPTED"
          ? `You are now connected with ${payload?.name} as a ${userTypeConvert(
              payload?.fromType as never,
              payload?.toType as never
            )}.`
          : `Connection with ${payload?.name} as a ${userTypeConvert(
              payload?.fromType as never,
              payload?.toType as never
            )} has been declined.`,
    });
  } catch (error: any) {
    utils.errorModal({
      title: "Error",
      body:
        error?.errors?.[0]?.message ||
        "Failed to approved connection , please try again.",
      show: true,
      type: "error",
    });
  }
}

export async function championRequestUsecase(payload: any, utils: UtilsUsecase) {
  try {
    await API.graphql({
      query: responseChampionRequest,
      variables: {
        championReqId: payload?.championReqId,
        status: payload?.purpose === "DECLINED" ? "DENIED" : "APPROVED",
      },
    });
    await utils.refetch();

    utils.successModal({
      show: true,
      title:
        payload?.purpose === "DECLINED"
          ? "Circle of Champion Invitation Declined"
          : "Circle of Champion Invitation Accepted",
      body:
        payload?.purpose === "DECLINED"
          ? `You have declined the request to join ${payload?.name}'s Circle of Champion`
          : `You have successfully accepted your invitation from ${payload?.name} to be honored as one of ${payload?.name} Champions`,
    });
  } catch (error: any) {
    utils.errorModal({
      title: "Error",
      body:
        error?.errors?.[0]?.message ||
        "invitation cicle of champion failed , please try again.",
      show: true,
      type: "error",
    });
  }
}

